import { appConfig } from "../configs/appConfig";
import { FormulaCase, IImage } from "../types/image";
import { Status } from "../types/status";
import { UserCheckStatus } from "../types/userCheck";

interface IGetImage {
  props: {};
  res: {
    status: Status;
    data: IImage | null;
  };
}

interface IGetImageAvailable {
  props: {};
  res: {
    status: Status;
    data: {
      counter: number;
    };
  };
}

interface ISaveCheck {
  props: {
    imageHash: string;
    status: UserCheckStatus;
    formula: string | null;
    formulaCase: FormulaCase | null;
    skippedComment: string | null;
  };
  res: {
    status: Status;
    data: {
      message: string;
    };
  };
}

class ImagesService {
  async getImage(): Promise<IGetImage["res"]> {
    const res = await fetch(appConfig.apiUrl + "/image", {
      method: "GET",
      credentials: "include",
    });

    const json = await res.json();

    return json;
  }

  async getAvailableImages(): Promise<IGetImageAvailable["res"]> {
    const res = await fetch(appConfig.apiUrl + "/image/available", {
      method: "GET",
      credentials: "include",
    });

    const json = await res.json();

    return json;
  }

  async saveCheck(props: ISaveCheck["props"]): Promise<ISaveCheck["res"]> {
    const res = await fetch(appConfig.apiUrl + `/image/check`, {
      method: "POST",
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(props),
    });

    const json = await res.json();

    return json;
  }

  deleteInReview() {
    navigator.sendBeacon(appConfig.apiUrl + "/image/deleteInReview");
  }
}

export default new ImagesService();
